import routeName from '../constant';

const routes = [
    {
        path: 'pay-change',
        name: routeName.PAY_CHANGE,
        component: () => import('@/views/aplCatl640and631/D1/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '自行繳費申請', leaveAlert: true, code: 'D1', unableBack: true },
    }];

export default routes;
